// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';
export var BackArrow = createSvgIcon({ LeftToRight: React.createElement(React.Fragment, null,
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M11 23L1 12 11 1M1 12h22" })), }, 'medium');
//# sourceMappingURL=BackArrow.js.map